
<div v-if="isVisible"
        class="badge badge-pill notransition"
        :class="durationClass">
    <i class="far fa-clock"></i>
    {{formattedDue}}
</div>
